import * as requestFromServer from './usersCrud';
import {usersSlice, callTypes} from './usersSlice';
import {transformUsers} from '../utils/transformUsers';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';

export const getUsersListIDPrefix = 'getUsersList';
const {actions} = usersSlice;

const getUsersList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getUsersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findUsers(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalUsersCount: totalCount, usersList, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: transformUsers(usersList)
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find users';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getUsers = getUsersList(actions.usersFetched);
export const getNextUsers = getUsersList(actions.usersAppended);

export const getPartnersOptions = () => dispatch => {
  return requestFromServer
    .getPartnersOptions()
    .then(response => {

      return response.data.data.partnersList;
    })
    .then(list => list.map(item => {
      const {name, uniqueId} = item;
      return {label: name, value: uniqueId};
    }))
    .then(options => {
      dispatch(actions.setPartnersOptions({options}));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find options';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const getPracticeAreaOptions = () => dispatch => {
  return requestFromServer
    .getPracticeAreaOptions()
    .then(response => {

      return response.data.data;
    })
    .then((list) => list.map(item => {
      const {label, value} = item;
      return {label: label, value: `${value}`};
    }))
    .then(options => {
      dispatch(actions.setPracticeAreaOptions({options}));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find options';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const exportUsersDataFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getUsersDataFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.usersList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

